var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-pagination',{attrs:{"page-size":20,"pager-count":11,"layout":" pager","total":100}})}
var staticRenderFns = []

export { render, staticRenderFns }